/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import Page from '../Pagination/Pagination'
import HeaderTable from '../BaseComponent/HeaderTable'
import $ from 'jquery'
import {message} from 'antd'
import {Link} from 'react-router-dom'
import jMoment from 'moment-jalaali'
import cookie from 'react-cookies'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import {accounting} from 'accounting'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import Loader from '../loaders/loader'

class ReportRejected extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      rejected: [],
      printInfo: [],
      listGeo: []
    }
  }
  getAllRejected = (
    params = sessionStorage.getItem('params'),
    pageNumber = sessionStorage.getItem('pageNumber'),
    pageSize = sessionStorage.getItem('dropDownVal'),
    sortBy = sessionStorage.getItem('sortBy')
  ) => {
    this.setState({
      loading: true
    })
    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_REJECTED
        }?export=false&pageNumber=${pageNumber}&pageSize=${pageSize}&${params}&sortBy=${sortBy}`,
        {}
      )
      .then((response) => {
        this.setState({
          loading: false
        })
        if (response.data.error === null) {
          this.setState({
            rejected: response.data.object.result,
            countAll: response.data.object.countAll
          })
          sessionStorage.setItem('countAll', response.data.object.countAll)
        } else {
          // message.error(response.data.description)
          this.setState({
            rejected: []
          })
        }
      })
      .catch(() => {
        this.setState({
          loading: false
        })
      })
  }

  componentDidMount() {
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.filterComponent').slideUp()
      })
    })

    http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_GEO}?type=3`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          listGeo: response.data.object
        })
      } else {
        this.setState({
          listGeo: ''
        })
      }
    })

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    sessionStorage.setItem('params', '')
    sessionStorage.setItem('sortBy', '')
    this.getAllRejected()
  }

  onResultFetched(data) {
    this.setState({
      rejected: data
    })
  }

  changeDropDown(data) {
    this.setState({
      rejected: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  changeSort(data) {
    this.setState({
      rejected: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  exportExcel = () => {
    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_REJECTED
        }?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}&${sessionStorage.getItem('sortBy')}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {}

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  getPrintInfo = () => {
    http
      .get(
        `${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_REJECTED}?export=true&${sessionStorage.getItem(
          'params'
        )}&${sessionStorage.getItem('sortBy')}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            printInfo: response.data.object.result
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 landscape;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  filter() {
    var invoiceId = document.getElementById('invoiceId').value.trim()
    var invoiceNum = document.getElementById('invoiceNum').value.trim()
    var buyerName = document.getElementById('buyerName').value.trim()
    var recipientName = document.getElementById('recipientName').value.trim()
    var mobile = document.getElementById('mobile').value.trim()
    var geoId = document.getElementById('geoId').value.trim()
    sessionStorage.setItem(
      'params',
      `invoiceId=${invoiceId}&invoiceNum=${invoiceNum}&buyerName=${buyerName}&recipientName=${recipientName}&mobile=${mobile}&geoId=${geoId}`
    )
    sessionStorage.setItem('sortBy', '')
    this.getAllRejected()
  }

  render() {
    let pageNumber = sessionStorage.getItem('pageNumber')
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let printCol = [
      'ردیف',
      'شناسه',
      'شناسه فاکتور',
      'شماره فاکتور',
      'قابل پرداخت',
      'منطقه',
      'آدرس',
      'خریدار',
      'تحویل گیرنده'
    ]

    let sortParams = [
      {title: 'تاریخ انتشار - صعودی', value: 'releaseTime_asc'},
      {title: 'تاریخ انتشار - نزولی', value: 'releaseTime_desc'}
    ]

    return (
      <div className="rtl printA4Page">
        <Loader show={this.state.loading} />

        <div className="printSection">
          <table className="printTable printReportTable landscapeTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش مرجوعی ها"
              headerColSpan={9}
              reporter={cookie.load('name')}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={4}
              rightColSpan={3}
              centerColSpan={2}
              centerSection={''}
              rightSection={''}
              columns={printCol}
            />
            <tbody>
              {this.state.printInfo.map((reject, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{reject.deliveryPackId}</td>
                  <td>{reject.invoiceId}</td>
                  <td>{reject.invoiceNum}</td>
                  <td className="priceCell">{accounting.formatMoney(reject.payableAmount, '', ',')}</td>
                  <td>{reject.geo.title}</td>
                  <td>{reject.address}</td>
                  <td>{reject.buyerName}</td>
                  <td>{reject.recipientName}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش مرجوعی ها.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'deliveryPackId'}
                field={'deliveryPackId'}
                title={'شناسه'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'invoiceId'}
                field={'invoiceId'}
                title={'شناسه فاکتور'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'invoiceNum'}
                field={'invoiceNum'}
                title={'شماره فاکتور'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'payableAmount'}
                field={'payableAmount'}
                title={'قابل پرداخت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'geo'}
                field={'geo.title'}
                title={'منطقه'}
                width="250px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'address'}
                field={'address'}
                title={'آدرس'}
                width="500px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'buyerName'}
                field={'buyerName'}
                title={'خریدار'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'recipientName'}
                field={'recipientName'}
                title={'تحویل گیرنده'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>پارت تحویل های برگشتی</li>
            <li>گزارش مرجوعی ها</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl=""
                  sort={false}
                  url={REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_REJECTED}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  changeSort={this.changeSort.bind(this)}
                  printUrl=""
                  titleAdd="افزودن ورژن"
                  sortParams={sortParams}
                  printLink=""
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>

            <div className="filterComponent">
              <div className="filterInputs">
                <div className="formComponent">
                  <label>شناسه فاکتور</label>
                  <input className="form-control" id="invoiceId" type="text" />
                </div>
                <div className="formComponent">
                  <label>شماره فاکتور</label>
                  <input className="form-control" id="invoiceNum" type="text" />
                </div>
                <div className="formComponent">
                  <label>خریدار</label>
                  <input className="form-control" id="buyerName" type="text" />
                </div>
                <div className="formComponent">
                  <label>تحویل گیرنده</label>
                  <input className="form-control" id="recipientName" type="text" />
                </div>
                <div className="formComponent">
                  <label>موبایل</label>
                  <input className="form-control" id="mobile" type="text" />
                </div>
                <div className="formComponent">
                  <label>منطقه شهرداری :</label>
                  <select className="form-control" id="geoId" name="geoId">
                    <option value="">------</option>
                    {this.state.listGeo.map((geo, index) => (
                      <option value={geo.id}>{geo.title}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>
            <div className="showBaseTable">
              <table className="baseTable">
                <tbody>
                  <tr>
                    <td>ردیف</td>
                    <td>شناسه</td>
                    <td>شناسه فاکتور</td>
                    <td>شماره فاکتور </td>
                    <td className="priceCell"> قابل پرداخت (ریال)</td>
                    <td> منطقه </td>
                    <td>آدرس</td>
                    <td>خریدار</td>
                    <td>تحویل گیرنده</td>
                  </tr>
                  {this.state.rejected.map((reject, index) => (
                    <tr>
                      <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                      <td>{reject.deliveryPackId}</td>
                      <td>{reject.invoiceId}</td>
                      <td>{reject.invoiceNum}</td>
                      <td className="priceCell">{accounting.formatMoney(reject.payableAmount, '', ',')}</td>
                      <td>{reject.geo.title}</td>
                      <td>{reject.address}</td>
                      <td>{reject.buyerName}</td>
                      <td>{reject.recipientName}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  total={this.state.countAll}
                  onResultFetched={this.onResultFetched.bind(this)}
                  url={REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_REJECTED}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default ReportRejected
